import { useSyncExternalStore } from 'react';

export default function useReducedMotion() {
  const subscribe = (callback: () => void) => {
    if (typeof window === 'undefined') {
      return () => {}; // No-op for server-side
    }
    const matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Use deprecated `addListener` and `removeListener` to support Safari < 14
    // https://usehooks-ts.com/react-hook/use-media-query
    if (matchMedia.addListener) {
      matchMedia.addListener(callback);
    } else {
      matchMedia.addEventListener('change', callback);
    }

    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(callback);
      } else if (matchMedia.removeEventListener) {
        matchMedia.removeEventListener('change', callback);
      }
    };
  };

  return useSyncExternalStore(
    subscribe,
    () => {
      if (typeof window === 'undefined') {
        return false; // Default value for SSR
      }
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    () => false // Default value
  );
}
